import React, { forwardRef } from "react";

const InputField = forwardRef(function (props, ref) {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    disabled,
    error, // <-- NEW PROP
    touched, // <-- NEW PROP
    ...others
  } = props;

  const isError = touched && error;

  return (
    <div className={`${extra}`}>
      {label && (
        <label
          htmlFor={id}
          className={`mb-1.5 text-xs ${
            disabled ? "text-gray-700" : "text-navy-700 dark:text-white"
          } ${variant === "auth" ? "ml-1.5 font-medium" : "ml-2"}`}
        >
          {label}
        </label>
      )}
      <input
        {...others}
        disabled={disabled}
        type={type}
        id={id}
        placeholder={placeholder}
        ref={ref}
        className={`flex h-10 w-full items-center justify-center rounded-3xl md:rounded-2xl border bg-white/0 px-3 py-2 text-sm outline-none ${
          disabled
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)] disabled:text-gray-700"
            : isError
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:border-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:border-green-400"
            : "border-gray-200 dark:border-gray-700 dark:text-white"
        }`}
      />
      {isError && <div className="text-red-500 text-xs mt-1">{error}</div>}
    </div>
  );
});

export default InputField;
